<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "../../../components/table/datatable";
import {required, email} from 'vuelidate/lib/validators'
import feedbackService from "../../../services/feedback.service";
import Vue from "vue";
import store from '@/state/store'

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Feedbacks",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Datatable, Layout, PageHeader},
  mounted() {
    this.fetchFeedbacks()

  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },

  },
  methods: {
    fetchFeedbacks(url, params) {
      return feedbackService.get(url, true, params)
    },
    onLoadData(data) {
      this.feedbacks = data
    },
    getBadgeClass(feedback){
      if(feedback.type == 'issue'){
        return 'badge-soft-danger'
      }else if(feedback.type == 'feedback'){
        return 'badge-soft-success'
      }else if(feedback.type == 'feature'){
        return 'badge-soft-success'
      }else{
        return 'badge-soft-warning'
      }
    }

  },

  data() {
    return {
      columns: ['email', 'type', 'message', 'action'],
      feedbacks: [],
      title: "Feedbacks",
      submitted: false,
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Feedbacks",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <datatable :columns="columns" :request="fetchFeedbacks" ref="users" :on-data-change="onLoadData">
      <tr v-for="feedback in feedbacks">
        <td>{{ feedback.email }}</td>
        <td ><span class="badge " :class="getBadgeClass(feedback)">{{ feedback.type }}</span></td>
        <td>{{ feedback.message }}</td>
        <td>
          <b-dropdown class="card-drop"
                      variant="white"
                      menu-class="dropdown-menu-end"
                      right
                      toggle-class="p-0">
            <template v-slot:button-content>
              <i class="mdi mdi-dots-horizontal font-size-18"></i>
            </template>
            <b-dropdown-item href="javascript: void(0);" @click="changePassword(feedback)">Change Password</b-dropdown-item>
          </b-dropdown>

        </td>
      </tr>
    </datatable>

  </Layout>
</template>